// Generated by web/tokens (node scripts/build.ts). Do not edit.
// Colours are resolved for the neutral Circles theme. Organisation themes change only the
// accent colours: see `themes` below and lib/accent.ts.

export const color = {
  light: {
    accentHighlight: '#F4A361',
    accentOnHighlight: '#16181D',
    accentAction: '#B85C1E',
    accentOnAction: '#FFFFFF',
    accentActionPressed: '#A34B02',
    accentSubtle: '#FDF0E6',
    accentOnSubtle: '#B05413',
    backgroundPrimary: '#FFFFFF',
    backgroundSecondary: '#F5F6F7',
    backgroundRail: '#FAFAFB',
    surfaceDefault: '#FFFFFF',
    surfaceRaised: '#FFFFFF',
    surfaceSunken: '#F5F6F7',
    surfaceHover: '#F5F6F7',
    surfacePressed: '#ECEDEF',
    surfaceScrim: '#10121666',
    surfaceCall: '#101216',
    textPrimary: '#16181D',
    textSecondary: '#5A5F67',
    textTertiary: '#6B7078',
    textDisabled: '#9DA1A8',
    textInverse: '#FFFFFF',
    textOnMedia: '#FFFFFF',
    textLink: '#B85C1E',
    iconPrimary: '#2B2E34',
    iconSecondary: '#6B7078',
    borderSubtle: '#ECEDEF',
    borderDefault: '#DEE0E3',
    borderStrong: '#C5C8CD',
    borderFocus: '#3376C6',
    bubbleIncoming: '#F5F6F7',
    bubbleOutgoing: '#FDF0E6',
    bubbleText: '#16181D',
    bubbleMeta: '#6B7078',
    bubbleQuoteBar: '#F4A361',
    bubbleQuote: '#1012160D',
    receiptSent: '#6B7078',
    receiptRead: '#3376C6',
    statusSuccess: '#3B7A1E',
    statusSuccessSubtle: '#F0FAE9',
    statusWarning: '#8A6A00',
    statusWarningSubtle: '#FFF8E5',
    statusDanger: '#CD2B31',
    statusDangerSubtle: '#FEF3F3',
    statusInfo: '#3376C6',
    statusInfoSubtle: '#F1F6FD',
    statusOnline: '#6FB048',
    callAccept: '#4F9A2C',
    callDecline: '#CD2B31',
    callOnAction: '#FFFFFF',
    callControl: '#FFFFFF24',
    callControlActive: '#FFFFFF',
    callOnControlActive: '#101216',
    callSpeaking: '#92CC6C',
    avatarOrangeBackground: '#FEE8D6',
    avatarOrangeForeground: '#8A4416',
    avatarGreenBackground: '#DDF3CF',
    avatarGreenForeground: '#2D5A17',
    avatarBlueBackground: '#DDEAFA',
    avatarBlueForeground: '#285EA2',
    avatarCoralBackground: '#FEE5E0',
    avatarCoralForeground: '#AC3120',
    avatarTealBackground: '#D3F2EE',
    avatarTealForeground: '#087368',
    avatarPurpleBackground: '#EBE7FD',
    avatarPurpleForeground: '#5E45A8',
  },
  dark: {
    accentHighlight: '#F4A361',
    accentOnHighlight: '#16181D',
    accentAction: '#F4A361',
    accentOnAction: '#16181D',
    accentActionPressed: '#FFBB86',
    accentSubtle: '#473528',
    accentOnSubtle: '#F4A361',
    backgroundPrimary: '#101216',
    backgroundSecondary: '#0A0B0D',
    backgroundRail: '#0A0B0D',
    surfaceDefault: '#181A1F',
    surfaceRaised: '#1F2227',
    surfaceSunken: '#1F2227',
    surfaceHover: '#181A1F',
    surfacePressed: '#23262C',
    surfaceScrim: '#000000A3',
    surfaceCall: '#101216',
    textPrimary: '#F2F3F5',
    textSecondary: '#A9ADB4',
    textTertiary: '#8A8F97',
    textDisabled: '#5A5F67',
    textInverse: '#101216',
    textOnMedia: '#FFFFFF',
    textLink: '#F4A361',
    iconPrimary: '#E4E6E9',
    iconSecondary: '#8A8F97',
    borderSubtle: '#23262C',
    borderDefault: '#2B2E34',
    borderStrong: '#42464D',
    borderFocus: '#649BE0',
    bubbleIncoming: '#1F2227',
    bubbleOutgoing: '#473528',
    bubbleText: '#F2F3F5',
    bubbleMeta: '#8A8F97',
    bubbleQuoteBar: '#F4A361',
    bubbleQuote: '#FFFFFF12',
    receiptSent: '#8A8F97',
    receiptRead: '#649BE0',
    statusSuccess: '#92CC6C',
    statusSuccessSubtle: '#1C2A15',
    statusWarning: '#F5D46E',
    statusWarningSubtle: '#2C2410',
    statusDanger: '#F07279',
    statusDangerSubtle: '#311618',
    statusInfo: '#649BE0',
    statusInfoSubtle: '#14223A',
    statusOnline: '#6FB048',
    callAccept: '#4F9A2C',
    callDecline: '#CD2B31',
    callOnAction: '#FFFFFF',
    callControl: '#FFFFFF24',
    callControlActive: '#FFFFFF',
    callOnControlActive: '#101216',
    callSpeaking: '#92CC6C',
    avatarOrangeBackground: '#8A4416',
    avatarOrangeForeground: '#FCD3B0',
    avatarGreenBackground: '#2D5A17',
    avatarGreenForeground: '#C1E8A8',
    avatarBlueBackground: '#1E477A',
    avatarBlueForeground: '#BBD4F4',
    avatarCoralBackground: '#AC3120',
    avatarCoralForeground: '#FEE5E0',
    avatarTealBackground: '#087368',
    avatarTealForeground: '#D3F2EE',
    avatarPurpleBackground: '#5E45A8',
    avatarPurpleForeground: '#EBE7FD',
  },
  palette: {
    orange50: '#FFF6EE',
    orange100: '#FEE8D6',
    orange200: '#FCD3B0',
    orange300: '#F9BC89',
    orange400: '#F4A361',
    orange500: '#E2853E',
    orange600: '#CC6E2A',
    orange700: '#B85C1E',
    orange800: '#8A4416',
    orange900: '#5C2D0E',
    green50: '#F0FAE9',
    green100: '#DDF3CF',
    green200: '#C1E8A8',
    green300: '#A9DB88',
    green400: '#92CC6C',
    green500: '#6FB048',
    green600: '#4F9A2C',
    green700: '#3B7A1E',
    green800: '#2D5A17',
    green900: '#1E3C10',
    blue50: '#F1F6FD',
    blue100: '#DDEAFA',
    blue200: '#BBD4F4',
    blue300: '#8FB8EC',
    blue400: '#649BE0',
    blue500: '#4787D4',
    blue600: '#3376C6',
    blue700: '#285EA2',
    blue800: '#1E477A',
    blue900: '#142F52',
    coral100: '#FEE5E0',
    coral400: '#EE6E59',
    coral700: '#AC3120',
    red50: '#FEF3F3',
    red100: '#FDE2E3',
    red300: '#F7A3A8',
    red400: '#F07279',
    red500: '#E5484D',
    red600: '#CD2B31',
    red700: '#A8232A',
    yellow50: '#FFF8E5',
    yellow300: '#F5D46E',
    yellow700: '#8A6A00',
    teal100: '#D3F2EE',
    teal400: '#4DB6A8',
    teal700: '#087368',
    purple100: '#EBE7FD',
    purple400: '#9C85EC',
    purple700: '#5E45A8',
    neutral0: '#FFFFFF',
    neutral25: '#FAFAFB',
    neutral50: '#F5F6F7',
    neutral100: '#ECEDEF',
    neutral150: '#E4E6E9',
    neutral200: '#DEE0E3',
    neutral300: '#C5C8CD',
    neutral400: '#9DA1A8',
    neutral500: '#7D828A',
    neutral550: '#6B7078',
    neutral600: '#5A5F67',
    neutral700: '#42464D',
    neutral750: '#33363C',
    neutral800: '#2B2E34',
    neutral850: '#23262C',
    neutral875: '#1F2227',
    neutral900: '#181A1F',
    neutral925: '#16181D',
    neutral950: '#101216',
    neutral975: '#0A0B0D',
    neutral1000: '#000000',
  },
} as const;

export const space = {
  none: 0,
  xxs: 2,
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 20,
  xxl: 24,
  xxxl: 32,
  huge: 48,
} as const;

export const radius = {
  none: 0,
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
  bubble: 18,
  bubbleTail: 6,
  full: 9999,
} as const;

export const size = {
  hitTarget: 44,
  iconSm: 16,
  iconMd: 20,
  iconLg: 24,
  iconXl: 28,
  avatarXs: 24,
  avatarSm: 32,
  avatarMd: 40,
  avatarLg: 50,
  avatarXl: 72,
  avatarXxl: 96,
  navBar: 52,
  tabBar: 56,
  sidebar: 72,
  listPane: 360,
  composer: 52,
  contentMax: 640,
} as const;

export const breakpoint = {
  twoPane: 640,
} as const;

export const typography = {
  largeTitle: { fontSize: 30, lineHeight: 36, fontWeight: 700, letterSpacing: -0.4 },
  title1: { fontSize: 24, lineHeight: 30, fontWeight: 700, letterSpacing: -0.3 },
  title2: { fontSize: 20, lineHeight: 26, fontWeight: 600, letterSpacing: -0.2 },
  headline: { fontSize: 16, lineHeight: 21, fontWeight: 600, letterSpacing: -0.1 },
  body: { fontSize: 16, lineHeight: 22, fontWeight: 400, letterSpacing: 0 },
  bodyStrong: { fontSize: 16, lineHeight: 22, fontWeight: 600, letterSpacing: 0 },
  callout: { fontSize: 15, lineHeight: 20, fontWeight: 400, letterSpacing: 0 },
  subheadline: { fontSize: 14, lineHeight: 19, fontWeight: 400, letterSpacing: 0 },
  footnote: { fontSize: 13, lineHeight: 18, fontWeight: 400, letterSpacing: 0 },
  caption: { fontSize: 12, lineHeight: 16, fontWeight: 500, letterSpacing: 0 },
  caption2: { fontSize: 11, lineHeight: 13, fontWeight: 500, letterSpacing: 0.1 },
} as const;

export const fontFamily = {
  apple: "'SF Pro Text', -apple-system, 'BlinkMacSystemFont'",
  android: "'Roboto'",
  windows: "'Segoe UI Variable Text', 'Segoe UI'",
  web: "-apple-system, 'BlinkMacSystemFont', 'Segoe UI Variable Text', 'Segoe UI', 'Roboto Variable', 'Roboto', system-ui, sans-serif",
  mono: "'SF Mono', ui-monospace, 'Cascadia Mono', 'Roboto Mono', monospace",
} as const;

export const motion = {
  durationFast: 120,
  durationBase: 200,
  durationSlow: 320,
  easingStandard: 'cubic-bezier(0.2, 0, 0, 1)',
  easingEnter: 'cubic-bezier(0, 0, 0, 1)',
  easingExit: 'cubic-bezier(0.3, 0, 1, 1)',
} as const;

export const elevation = {
  light: {
    level1: '0px 1px 2px 0px #1012160F, 0px 1px 3px 0px #10121614',
    level2: '0px 2px 6px 0px #1012160F, 0px 8px 24px -4px #1012161A',
    level3: '0px 4px 12px 0px #10121614, 0px 16px 40px -8px #10121626',
  },
  dark: {
    level1: '0px 1px 2px 0px #00000066, 0px 1px 3px 0px #00000040',
    level2: '0px 2px 6px 0px #00000066, 0px 8px 24px -4px #00000080',
    level3: '0px 4px 12px 0px #00000080, 0px 16px 40px -8px #00000099',
  },
} as const;

export const icon = {
  chats: {
    lucide: 'message-circle',
    sfSymbol: 'bubble.left.and.bubble.right',
    material: 'chat_bubble',
  },
  feed: { lucide: 'newspaper', sfSymbol: 'newspaper', material: 'newspaper' },
  calls: { lucide: 'phone', sfSymbol: 'phone', material: 'call' },
  you: { lucide: 'circle-user-round', sfSymbol: 'person.crop.circle', material: 'account_circle' },
  search: { lucide: 'search', sfSymbol: 'magnifyingglass', material: 'search' },
  compose: { lucide: 'square-pen', sfSymbol: 'square.and.pencil', material: 'edit_square' },
  add: { lucide: 'plus', sfSymbol: 'plus', material: 'add' },
  back: { lucide: 'chevron-left', sfSymbol: 'chevron.left', material: 'arrow_back' },
  chevronRight: { lucide: 'chevron-right', sfSymbol: 'chevron.right', material: 'chevron_right' },
  close: { lucide: 'x', sfSymbol: 'xmark', material: 'close' },
  more: { lucide: 'ellipsis', sfSymbol: 'ellipsis', material: 'more_horiz' },
  send: { lucide: 'send-horizontal', sfSymbol: 'paperplane.fill', material: 'send' },
  attach: { lucide: 'paperclip', sfSymbol: 'paperclip', material: 'attach_file' },
  camera: { lucide: 'camera', sfSymbol: 'camera', material: 'photo_camera' },
  photo: { lucide: 'image', sfSymbol: 'photo', material: 'image' },
  document: { lucide: 'file-text', sfSymbol: 'doc.text', material: 'description' },
  microphone: { lucide: 'mic', sfSymbol: 'mic', material: 'mic' },
  microphoneOff: { lucide: 'mic-off', sfSymbol: 'mic.slash', material: 'mic_off' },
  emoji: { lucide: 'smile-plus', sfSymbol: 'face.smiling', material: 'add_reaction' },
  reply: { lucide: 'reply', sfSymbol: 'arrowshape.turn.up.left', material: 'reply' },
  forward: { lucide: 'forward', sfSymbol: 'arrowshape.turn.up.right', material: 'forward' },
  edit: { lucide: 'pencil', sfSymbol: 'pencil', material: 'edit' },
  delete: { lucide: 'trash-2', sfSymbol: 'trash', material: 'delete' },
  copy: { lucide: 'copy', sfSymbol: 'doc.on.doc', material: 'content_copy' },
  pin: { lucide: 'pin', sfSymbol: 'pin', material: 'keep' },
  mute: { lucide: 'bell-off', sfSymbol: 'bell.slash', material: 'notifications_off' },
  archive: { lucide: 'archive', sfSymbol: 'archivebox', material: 'archive' },
  tickSent: { lucide: 'check', sfSymbol: 'checkmark', material: 'check' },
  tickDelivered: { lucide: 'check-check', sfSymbol: 'checkmark.circle', material: 'done_all' },
  play: { lucide: 'play', sfSymbol: 'play.fill', material: 'play_arrow' },
  pause: { lucide: 'pause', sfSymbol: 'pause.fill', material: 'pause' },
  phone: { lucide: 'phone', sfSymbol: 'phone.fill', material: 'call' },
  phoneOff: { lucide: 'phone-off', sfSymbol: 'phone.down.fill', material: 'call_end' },
  video: { lucide: 'video', sfSymbol: 'video.fill', material: 'videocam' },
  videoOff: { lucide: 'video-off', sfSymbol: 'video.slash.fill', material: 'videocam_off' },
  speaker: { lucide: 'volume-2', sfSymbol: 'speaker.wave.2.fill', material: 'volume_up' },
  switchCamera: {
    lucide: 'switch-camera',
    sfSymbol: 'arrow.triangle.2.circlepath.camera',
    material: 'cameraswitch',
  },
  addPerson: { lucide: 'user-plus', sfSymbol: 'person.badge.plus', material: 'person_add' },
  group: { lucide: 'users', sfSymbol: 'person.2', material: 'group' },
  like: { lucide: 'heart', sfSymbol: 'heart', material: 'favorite' },
  comment: { lucide: 'message-circle', sfSymbol: 'bubble.left', material: 'chat_bubble_outline' },
  repost: { lucide: 'repeat-2', sfSymbol: 'arrow.2.squarepath', material: 'repeat' },
  bookmark: { lucide: 'bookmark', sfSymbol: 'bookmark', material: 'bookmark' },
  views: { lucide: 'chart-no-axes-column', sfSymbol: 'chart.bar', material: 'bar_chart' },
  share: { lucide: 'share', sfSymbol: 'square.and.arrow.up', material: 'share' },
  poll: { lucide: 'chart-bar-big', sfSymbol: 'chart.bar.xaxis', material: 'poll' },
  official: { lucide: 'badge-check', sfSymbol: 'checkmark.seal.fill', material: 'verified' },
  expiry: { lucide: 'timer', sfSymbol: 'timer', material: 'timer' },
  lock: { lucide: 'lock', sfSymbol: 'lock.fill', material: 'lock' },
  key: { lucide: 'key-round', sfSymbol: 'key', material: 'key' },
  shield: { lucide: 'shield-check', sfSymbol: 'checkmark.shield', material: 'verified_user' },
  bell: { lucide: 'bell', sfSymbol: 'bell', material: 'notifications' },
  devices: {
    lucide: 'monitor-smartphone',
    sfSymbol: 'laptopcomputer.and.iphone',
    material: 'devices',
  },
  appearance: { lucide: 'sun-moon', sfSymbol: 'circle.lefthalf.filled', material: 'contrast' },
  help: { lucide: 'circle-help', sfSymbol: 'questionmark.circle', material: 'help' },
  logout: { lucide: 'log-out', sfSymbol: 'rectangle.portrait.and.arrow.right', material: 'logout' },
  mail: { lucide: 'mail', sfSymbol: 'envelope', material: 'mail' },
  request: { lucide: 'mail-plus', sfSymbol: 'envelope.badge', material: 'mark_email_unread' },
  settings: { lucide: 'settings', sfSymbol: 'gearshape', material: 'settings' },
  external: { lucide: 'building-2', sfSymbol: 'building.2', material: 'domain' },
  location: { lucide: 'map-pin', sfSymbol: 'mappin', material: 'location_on' },
  hashtag: { lucide: 'hash', sfSymbol: 'number', material: 'tag' },
} as const;

export type IconName = keyof typeof icon;

export interface AccentTokens {
  highlight: string;
  onHighlight: string;
  action: string;
  onAction: string;
  actionPressed: string;
  subtle: string;
  onSubtle: string;
}

export interface Theme {
  id: string;
  name: string;
  logo: string;
  feedHeader: string | null;
  emailDomains: readonly string[];
  accent: { seed: string; light: AccentTokens; dark: AccentTokens };
}

export const themes = {
  circles: {
    id: 'circles',
    name: 'Circles',
    logo: 'circles-logo.svg',
    feedHeader: null,
    emailDomains: [],
    accent: {
      seed: '#F4A361',
      light: {
        highlight: '#F4A361',
        onHighlight: '#16181D',
        action: '#B85C1E',
        onAction: '#FFFFFF',
        actionPressed: '#A34B02',
        subtle: '#FDF0E6',
        onSubtle: '#B05413',
      },
      dark: {
        highlight: '#F4A361',
        onHighlight: '#16181D',
        action: '#F4A361',
        onAction: '#16181D',
        actionPressed: '#FFBB86',
        subtle: '#473528',
        onSubtle: '#F4A361',
      },
    },
  },
  nordwind: {
    id: 'nordwind',
    name: 'Nordwind Logistik',
    logo: 'nordwind-logo.svg',
    feedHeader: 'nordwind-header.svg',
    emailDomains: ['nordwind-logistik.de'],
    accent: {
      seed: '#2B6CB0',
      light: {
        highlight: '#2B6CB0',
        onHighlight: '#FFFFFF',
        action: '#2B6CB0',
        onAction: '#FFFFFF',
        actionPressed: '#165A9D',
        subtle: '#DDE7F2',
        onSubtle: '#2869AD',
      },
      dark: {
        highlight: '#2B6CB0',
        onHighlight: '#FFFFFF',
        action: '#4283C9',
        onAction: '#16181D',
        actionPressed: '#5496DD',
        subtle: '#16283B',
        onSubtle: '#5091D8',
      },
    },
  },
  praxis: {
    id: 'praxis',
    name: 'Praxis am Park',
    logo: 'praxis-logo.svg',
    feedHeader: 'praxis-header.svg',
    emailDomains: ['praxis-am-park.de'],
    accent: {
      seed: '#3CC0A8',
      light: {
        highlight: '#3CC0A8',
        onHighlight: '#16181D',
        action: '#018673',
        onAction: '#FFFFFF',
        actionPressed: '#057262',
        subtle: '#E0F5F1',
        onSubtle: '#037C6A',
      },
      dark: {
        highlight: '#3CC0A8',
        onHighlight: '#16181D',
        action: '#3CC0A8',
        onAction: '#16181D',
        actionPressed: '#54D4BB',
        subtle: '#1B3C39',
        onSubtle: '#3CC0A8',
      },
    },
  },
} as const satisfies Record<string, Theme>;

/** Semantic colours that follow the accent. Apps resolve them from the active theme. */
export const accentAliases = {
  textLink: 'action',
  bubbleOutgoing: 'subtle',
  bubbleQuoteBar: 'highlight',
} as const;
